import { render, staticRenderFns } from "./DeptBaseInfo.vue?vue&type=template&id=50b74a3b&scoped=true&"
import script from "./DeptBaseInfo.vue?vue&type=script&lang=js&"
export * from "./DeptBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./DeptBaseInfo.vue?vue&type=style&index=0&id=50b74a3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b74a3b",
  null
  
)

export default component.exports